export type TerrainLayer = 'topsoil' | 'clay' | 'stone' | 'deep' | 'crystal' | 'core';

export interface ToolDefinition { name: string; radius: number; cooldown: number; cost: number; }
export const TOOLS: ToolDefinition[] = [
  { name: 'HAND SHOVEL', radius: .66, cooldown: .60, cost: 0 },
  { name: 'RUSTY SHOVEL', radius: .75, cooldown: .55, cost: 80 },
  { name: 'REINFORCED SHOVEL', radius: .86, cooldown: .49, cost: 180 },
  { name: 'OLD PICKAXE', radius: .98, cooldown: .43, cost: 360 },
  { name: 'HAND AUGER', radius: 1.10, cooldown: .36, cost: 700 },
  { name: 'POWER DRILL', radius: 1.24, cooldown: .29, cost: 1250 },
  { name: 'TITAN DRILL', radius: 1.42, cooldown: .22, cost: 2400 },
];

// Materials read by the crafting economy. `kind` groups them: raw ores smelt into ingots,
// fuel feeds the smelter, gems/valuables sell or enchant. `maxRoll` is a cumulative 0–10000
// threshold (rarest first); depth biases the roll toward the rare end.
export type MaterialKind = 'ore' | 'fuel' | 'gem' | 'valuable';
export interface LootDefinition { name: string; value: number; color: number; maxRoll: number; kind: MaterialKind; }
export const LOOT: LootDefinition[] = [
  { name: 'DIAMOND', value: 180, color: 0xdffcff, maxRoll: 35, kind: 'gem' },
  { name: 'RUBY', value: 85, color: 0xff305c, maxRoll: 120, kind: 'gem' },
  { name: 'SAPPHIRE', value: 55, color: 0x507aff, maxRoll: 320, kind: 'gem' },
  { name: 'GOLD NUGGET', value: 45, color: 0xffcf5a, maxRoll: 620, kind: 'valuable' },
  { name: 'EMERALD', value: 28, color: 0x41ef80, maxRoll: 1050, kind: 'gem' },
  { name: 'SILVER ORE', value: 20, color: 0xcfd6da, maxRoll: 1850, kind: 'ore' },
  { name: 'IRON ORE', value: 12, color: 0xa06854, maxRoll: 3600, kind: 'ore' },
  { name: 'OLD COIN', value: 9, color: 0xe7bd5f, maxRoll: 4300, kind: 'valuable' },
  { name: 'COPPER ORE', value: 7, color: 0xc8763a, maxRoll: 6000, kind: 'ore' },
  { name: 'BRITTLE COAL', value: 4, color: 0x2a2e31, maxRoll: 7900, kind: 'fuel' },
  { name: 'STONE', value: 2, color: 0x7c8588, maxRoll: 10000, kind: 'ore' },
];

export const LAYER_COLORS: Record<TerrainLayer, number> = {
  topsoil: 0x72452d,
  clay: 0x8d5139,
  stone: 0x657076,
  deep: 0x303d47,
  crystal: 0x35406b,
  core: 0x4a2a2c,
};

// Human-readable biome names for the HUD.
export const LAYER_NAMES: Record<TerrainLayer, string> = {
  topsoil: 'TOPSOIL',
  clay: 'CLAY',
  stone: 'STONE',
  deep: 'DEEP ROCK',
  crystal: 'CRYSTAL CAVERN',
  core: 'MOLTEN CORE',
};

export const layerAtDepth = (meters: number): TerrainLayer =>
  meters < 2.2 ? 'topsoil'
  : meters < 6 ? 'clay'
  : meters < 12 ? 'stone'
  : meters < 40 ? 'deep'
  : meters < 120 ? 'crystal'
  : 'core';
